// extracted by mini-css-extract-plugin
module.exports = {"answerCard":"AnswerCard_answerCard__KHAWf","textCenter":"AnswerCard_textCenter__2L0Yt"};